


export enum EnumStatusLoja {

    ABERTO = 1,
    FECHADO = 2
  }